// SplashScreen.js
import React from "react";
import "./splash-screen.css"; // Créez un fichier CSS pour styliser votre écran de démarrage

const SplashScreen = () => {
  return (
    <div className="splash-screen">
      <div className="hero min-h-screen bg-base-200">
        <div className="hero-content text-center">
          <div className="max-w-4xl">
            <h1 className=" text-pop-up-top  text-6xl font-bold text-pop-up-top gradient-text">
              La carte mentale  du 
            </h1>
            <h1 className=" text-pop-up-top text-6xl font-bold text-pop-up-top gradient-text">
              Développeur Front-end 
            </h1>
            <blockquote>
              <p className="py-6 text-xl">
                "L'informatique est une discipline étrange. En théorie, tout est
                possible.<br/> En pratique, tout est _________." - Bravo !
              </p>
            </blockquote>
            <p className="text-gray-400">Dev Mind Mapper V 0.0.1</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
